/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Oficina Automóvel em Oliveira de Azeméis | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Oficina Roady em Oliveira de Azeméis: revisões, pneus, mudança de óleo, travões e diagnóstico. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'oficina oliveira de azeméis, pneus oliveira de azeméis, revisão automóvel oliveira de azeméis, mecânica oliveira de azeméis, roady oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/'
    },
    pneus: {
        title: 'Pneus em Oliveira de Azeméis | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Pneus ao melhor preço em Oliveira de Azeméis. Montagem, equilíbrio e válvulas. Marcar online no Roady Centro-Auto.',
        keywords: 'pneus oliveira de azeméis, comprar pneus, montagem pneus',
        canonical: 'https://roadyoliveiraazemeis.com/loja/pneus'
    },

    // Workshop (Services Overview)
    workshop: {
        title: 'Serviços de Oficina em Oliveira de Azeméis | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Revisão, pneus, óleo, travões, alinhamento e diagnóstico em Oliveira de Azeméis. Veja todos os serviços do Roady Oliveira de Azeméis e peça orçamento sem compromisso.',
        keywords: 'serviços automóvel oliveira de azeméis, oficina oliveira de azeméis, mecânica oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina'
    },

    // Service Details
    'revisoes-roady': {
        title: 'Revisão Automóvel em Oliveira de Azeméis | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Revisão completa em Oliveira de Azeméis, sem perder a garantia do seu carro. Veja o que está incluído e peça orçamento sem compromisso.',
        keywords: 'revisão automóvel oliveira de azeméis, revisão carro oliveira de azeméis, manutenção automóvel',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/revisoes-roady'
    },
    'alinhamento': {
        title: 'Alinhamento de Direção em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Alinhamento profissional em Oliveira de Azeméis. Menos desgaste nos pneus, condução segura e precisa. Peça orçamento sem compromisso.',
        keywords: 'alinhamento oliveira de azeméis, alinhamento direção oliveira de azeméis, geometria oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/alinhamento'
    },
    'teste-diagnostico': {
        title: 'Diagnóstico Eletrónico em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Diagnóstico eletrónico completo para todas as marcas. Identificação rápida e precisa de avarias. Roady Centro-Auto Oliveira de Azeméis.',
        keywords: 'diagnóstico automóvel oliveira de azeméis, teste eletrónico oliveira de azeméis, diagnóstico carro',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/teste-diagnostico'
    },
    'travoes': {
        title: 'Serviço de Travões em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Substituição de pastilhas e discos de travão em Oliveira de Azeméis. Segurança garantida com profissionais Roady.',
        keywords: 'travões oliveira de azeméis, pastilhas travão oliveira de azeméis, discos travão oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/travoes'
    },
    'amortecedores': {
        title: 'Amortecedores em Oliveira de Azeméis — Roady Centro-Auto | Troca e Revisão',
        description: 'Troca e revisão de amortecedores em Oliveira de Azeméis. Estabilidade e segurança com serviço Roady certificado.',
        keywords: 'amortecedores oliveira de azeméis, suspensão oliveira de azeméis, troca amortecedores',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/amortecedores'
    },
    'inspecao': {
        title: 'Pré-Inspeção Automóvel em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Prepare o seu carro para a inspeção com o serviço Roady em Oliveira de Azeméis. Verificação completa e rápida.',
        keywords: 'pré-inspeção oliveira de azeméis, inspeção automóvel oliveira de azeméis, preparação inspeção',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/inspecao'
    },
    'mecanica-geral': {
        title: 'Mecânica Automóvel em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Mecânica automóvel completa em Oliveira de Azeméis. Reparações e manutenção com técnicos especializados Roady.',
        keywords: 'mecânica geral oliveira de azeméis, reparação automóvel oliveira de azeméis, mecânico oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/mecanica-geral'
    },
    'ar-condicionado': {
        title: 'Carregamento de Ar Condicionado Auto em Oliveira de Azeméis | Roady',
        description: 'Carregamento e manutenção do ar condicionado do seu carro em Oliveira de Azeméis. Saiba quando é preciso e peça orçamento sem compromisso.',
        keywords: 'ar condicionado auto oliveira de azeméis, carga AC oliveira de azeméis, reparação AC automóvel',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/ar-condicionado'
    },
    'baterias': {
        title: 'Baterias Automóvel em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Teste e substituição de baterias automóvel em Oliveira de Azeméis. Instalação com garantia Roady.',
        keywords: 'baterias auto oliveira de azeméis, bateria carro oliveira de azeméis, substituição bateria',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/baterias'
    },
    'restauro-farois': {
        title: 'Restauro de Faróis em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Restauro profissional de faróis automóvel. Melhore a visibilidade e segurança. Roady Oliveira de Azeméis.',
        keywords: 'restauro faróis oliveira de azeméis, polimento faróis oliveira de azeméis, recuperação faróis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/restauro-farois'
    },
    'lavagem': {
        title: 'Lavagem Auto em Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Serviços de lavagem automóvel completos em Oliveira de Azeméis. Interior e exterior com profissionais Roady.',
        keywords: 'lavagem auto oliveira de azeméis, limpeza carro oliveira de azeméis, lavagem completa',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/lavagem'
    },
    'servicos-oficina': {
        title: 'Plano de Serviços Oficina — Roady Centro-Auto',
        description: 'Planos de serviços e manutenção para a sua oficina. Soluções completas Roady em Oliveira de Azeméis.',
        keywords: 'plano serviços oliveira de azeméis, manutenção oficina oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/oficina/servicos-oficina'
    },

    // Store & Categories
    store: {
        title: 'Loja Auto em Oliveira de Azeméis — Roady Centro-Auto | Peças e Acessórios',
        description: 'Óleos, acessórios, produtos auto, limpeza e manutenção. Loja Roady Oliveira de Azeméis.',
        keywords: 'loja auto oliveira de azeméis, peças automóvel oliveira de azeméis, acessórios auto oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/loja'
    },
    'loja-eletricidade': {
        title: 'Eletricidade Automóvel — Loja Roady Oliveira de Azeméis',
        description: 'Componentes elétricos, baterias e acessórios elétricos para automóvel. Roady Oliveira de Azeméis.',
        keywords: 'eletricidade auto oliveira de azeméis, componentes elétricos carro',
        canonical: 'https://roadyoliveiraazemeis.com/loja/eletricidade'
    },
    'loja-equipamento-interior': {
        title: 'Equipamento Interior Auto — Loja Roady Oliveira de Azeméis',
        description: 'Acessórios e equipamentos para interior do automóvel. Qualidade garantida Roady.',
        keywords: 'equipamento interior auto, acessórios interior carro oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/loja/equipamento-interior'
    },
    'loja-equipamento-exterior': {
        title: 'Equipamento Exterior Auto — Loja Roady Oliveira de Azeméis',
        description: 'Acessórios e equipamentos para exterior do automóvel. Loja Roady Oliveira de Azeméis.',
        keywords: 'equipamento exterior auto, acessórios exterior carro oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/loja/equipamento-exterior'
    },
    'loja-lubrificantes': {
        title: 'Lubrificantes e Óleos Auto — Loja Roady Oliveira de Azeméis',
        description: 'Óleos motor, lubrificantes e produtos de manutenção. Marcas de confiança na Roady Oliveira de Azeméis.',
        keywords: 'óleo motor oliveira de azeméis, lubrificantes auto oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/loja/lubrificantes'
    },
    'loja-manutencao': {
        title: 'Produtos de Manutenção Auto — Loja Roady Oliveira de Azeméis',
        description: 'Produtos de manutenção e cuidado automóvel. Roady Oliveira de Azeméis.',
        keywords: 'produtos manutenção auto, cuidado automóvel oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/loja/manutencao'
    },
    'loja-pecas-tecnicas': {
        title: 'Peças Técnicas Auto — Loja Roady Oliveira de Azeméis',
        description: 'Peças técnicas e componentes para automóvel. Qualidade garantida Roady.',
        keywords: 'peças técnicas auto oliveira de azeméis, componentes carro',
        canonical: 'https://roadyoliveiraazemeis.com/loja/pecas-tecnicas'
    },
    'loja-pneus': {
        title: 'Pneus em Oliveira de Azeméis | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Pneus para o seu carro em Oliveira de Azeméis. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus oliveira de azeméis, comprar pneus oliveira de azeméis, montagem pneus',
        canonical: 'https://roadyoliveiraazemeis.com/loja/pneus'
    },
    'loja-som-multimedia-navegacao': {
        title: 'Som, Multimédia e Navegação — Loja Roady Oliveira de Azeméis',
        description: 'Sistemas de som, multimédia e navegação GPS para automóvel. Roady Oliveira de Azeméis.',
        keywords: 'som auto oliveira de azeméis, GPS carro oliveira de azeméis, multimédia automóvel',
        canonical: 'https://roadyoliveiraazemeis.com/loja/som-multimedia-navegacao'
    },
    'loja-ferramentas': {
        title: 'Ferramentas Auto — Loja Roady Oliveira de Azeméis',
        description: 'Ferramentas profissionais e acessórios para manutenção automóvel. Roady Oliveira de Azeméis.',
        keywords: 'ferramentas auto oliveira de azeméis, ferramentas mecânica',
        canonical: 'https://roadyoliveiraazemeis.com/loja/ferramentas'
    },

    // Other Pages
    budget: {
        title: 'Peça Orçamento Automóvel em Oliveira de Azeméis | Roady Oliveira de Azeméis',
        description: 'Peça orçamento para revisão, pneus, travões ou mudança de óleo no Roady Oliveira de Azeméis. Diga-nos o que o carro precisa e respondemos com um valor claro.',
        keywords: 'orçamento auto oliveira de azeméis, pedir orçamento oficina oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/orcamento'
    },
    mobility: {
        title: 'Mobilidade Urbana Oliveira de Azeméis — Roady Centro-Auto',
        description: 'Bicicletas e trotinetes elétricas em Oliveira de Azeméis. Assistência e apoio Roady.',
        keywords: 'mobilidade oliveira de azeméis, bicicletas elétricas oliveira de azeméis, trotinetes oliveira de azeméis',
        canonical: 'https://roadyoliveiraazemeis.com/mobilidade'
    },
    recruitment: {
        title: 'Recrutamento — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Junte-se à equipa Roady Centro-Auto Oliveira de Azeméis. Procuramos talento para o setor automóvel. Envie candidatura.',
        keywords: 'emprego oliveira de azeméis, trabalho oficina oliveira de azeméis, recrutamento roady',
        canonical: 'https://roadyoliveiraazemeis.com/recrutamento'
    },
    contact: {
        title: 'Contactos e Horário | Roady Centro-Auto Oliveira de Azeméis',
        description: 'Morada, horário, telefone e WhatsApp do Roady Centro-Auto Oliveira de Azeméis. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'contacto roady oliveira de azeméis, telefone oficina oliveira de azeméis, morada roady',
        canonical: 'https://roadyoliveiraazemeis.com/contacto'
    },
    wecall: {
        title: 'Ligamos-lhe — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Deixe os seus dados e ligamos-lhe. Atendimento personalizado Roady Oliveira de Azeméis.',
        keywords: 'contacto roady oliveira de azeméis, ligação gratuita',
        canonical: 'https://roadyoliveiraazemeis.com/ligamos'
    },
    wishlist: {
        title: 'Lista de Desejos — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Guarde os seus produtos favoritos na lista de desejos. Loja Roady Oliveira de Azeméis.',
        canonical: 'https://roadyoliveiraazemeis.com/lista-desejos'
    },

    // Legal Pages
    cookies: {
        title: 'Política de Cookies — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Política de cookies do website Roady Centro-Auto Oliveira de Azeméis. Saiba como utilizamos cookies.',
        canonical: 'https://roadyoliveiraazemeis.com/politica-cookies'
    },
    privacy: {
        title: 'Política de Privacidade — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Política de privacidade e proteção de dados do Roady Centro-Auto Oliveira de Azeméis.',
        canonical: 'https://roadyoliveiraazemeis.com/politica-privacidade'
    },
    terms: {
        title: 'Termos e Condições — Roady Centro-Auto Oliveira de Azeméis',
        description: 'Termos e condições de utilização do website Roady Centro-Auto Oliveira de Azeméis.',
        canonical: 'https://roadyoliveiraazemeis.com/termos-condicoes'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.workshop;
};

/**
 * Get SEO data for a store category page
 */
export const getStoreCategorySEO = (categorySlug: string): PageSEO => {
    const key = `loja-${categorySlug}`;
    return seoData[key] || seoData.store;
};

